<template>
  <div class="page_1" :class="isHide ? 'page_2' : ''">
    <div class="new_class">
      <div class="inner_new_class">
        <div v-for="(item,index) in tabBarList" :key="index"  class="new_class_item" @click="expend(index)">
            <span id="all_class" :class="{new_class_on : item.active}">{{item.name}}</span>
            <img src="../../../assets/image/nsale/arrow2.png" alt="下拉">
        </div>
      </div>
    </div>
    <div class="fixed_bg" v-if="showBg" @click="closeBg()">
      <div class="all_class" v-if="currentIndex == 0">
          <div class="inner_all_class">
              <div class="left_class">
                  <div class="cls_list">
                      <ul>
                        <li v-for="(item,index) in bigClassList" :key="index" class="cla_item" :class="{ left_class_selected : leftClassSelectedCode == item.classCode}" @click="initClassItem(item.classCode,$event)">
                          {{item.productClassName}}
                        </li>
                      </ul>
                  </div>
              </div>
              <div class="right_class">
                  <div class="right_cls_list">
                      <ul>
                        <li v-for="(item,index) in middleClassList" :key="index" @click="checkedRelateItem(item.id,item.name,$event)" :class="{right_class_selected : searchParams.productClassTwo == item.id}">
                          <img src="../../../assets/image/nsale/right.png" alt="" v-if="searchParams.productClassTwo == item.id">
                          <span class="txt" :class="{blod_ : searchParams.productClassTwo == item.id}">{{item.productClassName}}</span>
                        </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
      <div class="company_class" v-if="currentIndex == 1">
          <div class="inner_company_class">
            <p v-for="(item,index) in companyClassList" :key="index" class="company_class_item" :class="{company_class_selected : searchParams.companyTagId.indexOf(item.tagId) != -1}" @click="checkedCompanyClassItem(item.tagId,$event)">
              {{item.tagName}}
            </p>
          </div>
      </div>
      <div class="tag_class" v-if="currentIndex == 2">
          <div class="inner_tag_class">
            <div v-for="(item,index) in tagClassList" :key="index" class="tag_class_item">
                <p class="tag_title">{{item.tagClassName}}</p>
                <div class="tags_">
                    <p v-for="(item2,index2) in item.productTagInfoRspDtoList" :key="index2" class="tag_" :class="{tag_class_selected : searchParams.tagId.indexOf(item2.tagId) != -1 || searchParams.wxTagId.indexOf(item2.tagId) != -1}" @click="checkedTagClassItem(item2.tagId,item2.mainId,$event)">{{item2.tagName}}</p>
                </div>
            </div>
          </div>
      </div>
      <div class="foot" v-if="currentIndex != 0">
          <button class="cls_btn reset_btn" @click="resetClass($event)">
              重置
          </button>
          <button class="cls_btn confirm_btn" @click="comfirmClass($event)">
              确定
          </button>
      </div>
    </div>
    <div class="list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item"
        @click="goDetail(item)"
      >
        <div class="proImg_">
          <div class="tagbox" v-if="item.productLeftTag"><div class="tag-text">{{item.productLeftTag}}</div></div>
          <img :src="item.productPicuter" alt="" />
          <div class="company_">{{ item.productDigest }}</div>
        </div>
        <div class="right_">
          <p class="title">{{ item.productName }}</p>
          <div v-html="item.prooductSellPoint" class="risk source_"></div>
          <p class="bottom_">
            <span class="price">{{ item.productPrice }}</span
            ><span class="unit_">元起</span>
          </p>
        </div>
      </div>
    </div>
    <div class="btn" v-if="query.type == 1">
      <span class="use" @click="save" v-if="isNewAdd">保存常用</span>
      <span class="use" @click="modify" v-else>修改常用</span>
      <span class="txt" @click="extension">转发组合推广</span>
    </div>
    <div class="mask" v-show="showMask" @click="hideMask">
      <img src="../../../assets/image/nsale/guide.png" alt="" />
    </div>
    <!-- 官方推荐活动被删除遮罩 -->
    <div class="mask_notactive" v-if="notActive">
        <p class="desc">组合已失效</p>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  data() {
    document.title = "组合推广";
    return {
      notActive: false,
      list: [],
      tabList: [
        {
          value: "0",
          name: "全部",
        },
      ],
      typeIdList: [],
      columnIndex: 0,
      queryParam: {
        start: 1,
        length: 10,
        noPage: 1,
      },
      query: {},
      productIds: [],
      data: [],
      height: "",
      showBar: false,
      showMask: false,
      userId: "",
      avatarUrl: "",
      productName: "",
      isNewAdd: true,
      shareTitle: '',
      shareContent: '',
      tabBarList: [
        {
          name: '全部分类',
          active: false
        },
        {
          name: '公司筛选',
          active: false
        },
        {
          name: '标签筛选',
          active: false
        }
      ],
      currentIndex: 4,
      showBg: false,
      bigClassList: [],
      middleClassList: [],
      companyClassList: [],
      tagClassList: [],
      leftClassSelectedCode: '',
      productClassTwo: [],
      searchParams : {
        companyTagId: [],
        mainId: null,
        defaultUserId: null,
        productClass: '',
        productClassId: '',
        productClassTwo: '',
        productName: '',
        tagId: [],
        wxTagId: [],
        productTransactionCodes: []
      },
      isHide: false,
      originTagList: []
    };
  },
  created() {
    this.query = this.$route.query;
    this.userId = this.query.userId;
    if (this.query.from == 'front') {
      this.isNewAdd = false
    }
    window.addEventListener("scroll", this.handleScroll, true);
    this.queryUser();
    
    this.getProductByTransactionCodes();
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    getProductByTransactionCodes() {
      api.getProductByTransactionCodes(this.query).then((res) => {
        if (!res.data.content) {
          this.notActive = true;
          return
        }
        let productCombinationSpread = Array.isArray(res.data.content.productCombinationSpread) ? res.data.content.productCombinationSpread[0] : res.data.content.productCombinationSpread;
        this.shareTitle = !productCombinationSpread || !productCombinationSpread.shareTitle ? '产品推荐' : productCombinationSpread.shareTitle
        this.shareContent = !productCombinationSpread || !productCombinationSpread.shareContent ? '我为您精选了系列保险产品，打开看看吧~' : productCombinationSpread.shareContent
        // 产品大类
        
        let { productList,productClassList,companyTags,tagListTags } = res.data.content;
        this.list = productList;
       
        this.bigClassList = productClassList || []
        this.companyClassList = companyTags
        this.tagClassList = tagListTags
        if (tagListTags && tagListTags.length > 0) {
          this.originTagList = JSON.parse(JSON.stringify(tagListTags))
        }
        this.fetchJsSdkSign();
      });
    },
    queryComProductTagList() {
      this.searchParams.mainId = parseInt(this.query.mainId)
      this.searchParams.defaultUserId = parseInt(this.query.userId)
      this.searchParams.productClass = this.leftClassSelectedCode
      this.searchParams.productClassId = this.leftClassSelectedCode
      this.searchParams.productTransactionCodes = this.query.productTransactionCodes ? this.query.productTransactionCodes.split(',') : []
      api.queryComProductTagList(this.searchParams).then(res => {
        this.tagClassList = res.data.content
      })
    },
    modify() {
      this.updateProductCombinationSpread()
    },
    updateProductCombinationSpread() {
      let id = this.query.queryId
      let params = {
        productTransactionCodes: this.query.productTransactionCodes,
      }
      api.updateProductCombinationSpread(id,params).then(res => {
        window.$toast('修改成功')
        this.$router.push({
          path: "/bs/myCombinations",
          query: this.query,
        });
     })
    },
    save() {
      this.dialog = this.$createDialog({
        type: "prompt",
        title: "请输入组合名称",
        prompt: {
          value: "",
          placeholder: "请输入",
        },
        onConfirm: (e, promptValue) => {
          let params = {
            ...this.query,
            combinationName: promptValue,
          };
          this.saveProductCombinationSpread(params);
        },
      }).show();
    },
    saveProductCombinationSpread(data) {
      api.saveProductCombinationSpread(data).then((res) => {
        this.$router.push({
          path: "/bs/myCombinations",
          query: this.query,
        });
      });
    },
    queryUser() {
      api
        .queryUser({ userId: this.userId })
        .then((res) => res.data)
        .then((data) => {
          const { imageUrl } = data.content;
          this.avatarUrl = imageUrl;
        });
    },
    fetchJsSdkSign() {
      let url = location.href.split("#")[0];
      this.linkurl = url;
      let _this = this;
      api
        .getJsJdkSign2({
          url: url,
          userId: this.userId,
        })
        .then((res) => res.data)
        .then(async (data) => {
          const { appId, jssdkReqData } = data;
          let options = {
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["showOptionMenu", "updateTimelineShareData", "updateAppMessageShareData"],
          }
          const { wxShare, wxShowMenu } = await this.$wx.wxConfig(options)
          wxShowMenu();
          let urlArr = window.location.href.split("&type=1")
          let url = urlArr[0]
          if (urlArr[1]) {
            url += urlArr[1]
          }
          let opstion = {
            title: _this.shareTitle, // 分享标题
            link: url,
            imgUrl: _this.avatarUrl || "http://nsale.yutai365.com/icon.jpg", // 分享图标
            desc: _this.shareContent,
          };
          wxShare(opstion)
        });
    },
    // 跳转投保前黑名单校验
    async validBlackList(productCode) {
      let flag = false
      await api.verifyWhetherVisitorProductPage(this.userId, productCode).then(res => {
        if (res.data.returnCode == '0000' && res.data.content == 'Y') {
					flag = true
			  } else {
          this.$toast('账号暂无该产品出单权限')
        }
      })
      return flag
    },
    async goDetail(info) {
      let flag = await this.validBlackList(info.productCode)
      if(!flag) {
        return
      }
      let data = {
        productCode: info.productCode,
        mainId: this.$route.query.mainId,
        productUrl: "",
      };
      this.toubao(data);
    },
    toubao({ productCode, mainId, productUrl, from }) {
      this.checkIsNeedLogin({productCode: productCode,defaultUserId: this.query.userId,productUrl: productUrl,from: from,mainId: mainId});
    },
    async checkIsNeedLogin(params) {
      // let isNeedLogin = await api.checkIsNeedLogin()
      // if(isNeedLogin=="Y"){
      //   this.$toast("请先登录或者注册")
      //   return
      // }
      this.checkHotAndBannerProduct(params);
    },
    async checkHotAndBannerProduct(params) {
      let url
      let checkResult = await api.checkHotAndBannerProduct(params)
      if(checkResult && checkResult.data!="1"){
        this.$toast("账号未绑定或产品未配置，无法投保！")
        return
      }
      if(params.productCode && 'null' != params.productCode){
        this.judgeOnlyPcOrCpsAndGetPosterUrl(params);
      }else{
        url = params.productUrl;
        if (params.from !== undefined){
          url = url + convert(url,params.from);
        }

        window.location.href = url;
        }
    },
    async judgeOnlyPcOrCpsAndGetPosterUrl(params) {
      let content = await api.judgeOnlyPcOrCpsAndGetPosterUrl(params.productCode)
      console.log(content);
      if(content.data.content.judgeFlag=='1'){
        this.$router.push('/bs/PCPolicyGuide')
        return;
      }
      let url = "/authority/wxstore/getProductWechatUrl?productCode="+params.productCode+"&mainId="+params.mainId+"&userId="+this.query.userId;
      let origin = "http://wx.run4wd.com";
      if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
        origin = "https://wx.yutai365.com";
      }
      if (!/^http/.test(url)) {
        url = `${origin}${url}`;
      }
      window.location.href = url;
      },
    changeTab(index, tabCode) {
      this.list = [];
      this.data.forEach((item) => {
        if (tabCode == "0") {
          this.list = this.data;
        } else if (item.productClass == tabCode) {
          this.list.push(item);
        }
      });
      this.columnIndex = index;
    },
    handleScroll(e) {
      var top = Math.floor(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageXOffset
      );
      this.height = top;
    },
    extension() {
      this.showMask = true;
    },
    hideMask() {
      this.showMask = false;
    },
    expend(index) {
      this.$set(this.tabBarList[index],'active',true)
      // this.tabBarList[index].active = true
      // this.activeItem()
      if (this.currentIndex == index) {
        this.showBg = !this.showBg
      } else {
        this.showBg = true
        this.currentIndex = index
      }
      this.isHide = this.showBg ? true : false
    },
    activeItem() {
      if (!this.searchParams.productClassTwo && !this.searchParams.productClass) {
        this.tabBarList[0].active = false
        // this.leftClassSelectedCode = ''
        // this.tagClassList = []
      } else {
        this.tabBarList[0].active = true
      }
      if (!this.searchParams.companyTagId.length > 0) {
        this.tabBarList[1].active = false
      } else {
        this.tabBarList[1].active = true
      }
      if (!this.searchParams.tagId.length > 0 && !this.searchParams.wxTagId.length > 0) {
        this.tabBarList[2].active = false
      } else {
        this.tabBarList[2].active = true
      }
      // if (this.tabBarList[0].active || this.tabBarList[1].active || this.tabBarList[2].active) {
      //   this.isHide =  true
      // } else {
      //   this.isHide =  false
      // }
    },
    initClassItem(classCode,e) {
      e.stopPropagation()
      if (this.leftClassSelectedCode == classCode) {
        this.leftClassSelectedCode  = ''
        this.searchParams.productClass = ''
        this.searchParams.productClassTwo = ''
        this.middleClassList = []
        this.isHide = false
        this.showBg = false
        // this.tagClassList = []
        this.searchParams.tagId = []
        this.searchParams.wxTagId = []
        this.tagClassList = this.originTagList
        // this.tabBarList[2].active = false
        this.activeItem()
        // if (!this.searchParams.productClass && !this.searchParams.productClassTwo && this.searchParams.companyTagId.length == 0 && this.searchParams.tagId == 0) {
          this.initMallProduct()
        // }
        return false
      }
      this.tabBarList[2].active = false
      this.searchParams.tagId = []
      this.middleClassList = []
      this.searchParams.productClassTwo = ''
      this.leftClassSelectedCode = classCode
      let bigClass = this.bigClassList.filter(item => item.classCode == classCode)[0]
      this.middleClassList = bigClass.productClassTwoList
      let index = this.middleClassList.findIndex(item => item.id == '10')
      if (index == -1) {
        this.middleClassList.unshift(
        {
          id:'10',
          productClassName:`全部${bigClass.productClassName}`,
          productClassId:'',
          status:null,
          creator:null,
          createDate:null,
          modifier:null,
          modifyDate:null
        })
      }
      this.queryComProductTagList()
    },
    checkedRelateItem(id,name,e) {
      e.stopPropagation()
      if (this.searchParams.productClassTwo ==  id) {
        this.searchParams.productClassTwo = ''
        this.leftClassSelectedCode = ''
        this.searchParams.productClass = ''
        this.middleClassList = []
      } else {
        this.searchParams.productClassTwo = id
      }
      this.showBg = false
      this.isHide = false
      this.activeItem()
      this.initMallProduct()
      // let index = this.searchParams.productClassTwo.findIndex(item => item == id)
      // if (index == -1) {
      //   this.searchParams.productClassTwo = []
      //   this.searchParams.productClassTwo.push(id)
      // } else {
      //   this.searchParams.productClassTwo.splice(index,1)
      // }
    },
    resetClass(e) {
      e.stopPropagation()
      if (this.currentIndex == 0) {
        this.productClassTwo = []
      } else if (this.currentIndex == 1) {
        this.searchParams.companyTagId = []
      } else {
        this.searchParams.tagId = []
        this.searchParams.wxTagId = []
      }
    },
    comfirmClass(e) {
      e.stopPropagation()
      this.showBg = false
      this.isHide = false
      this.activeItem()
      this.initMallProduct()
    },
    checkedCompanyClassItem(id,e) {
      this.searchParams.mainId = parseInt(this.query.mainId)
      this.searchParams.defaultUserId = parseInt(this.query.userId)
      e.stopPropagation()
      let index = this.searchParams.companyTagId.findIndex(item => item == id)
      if (index == -1) {
        this.searchParams.companyTagId.push(id)
      } else {
        this.searchParams.companyTagId.splice(index,1)
      }
    },
    checkedTagClassItem(id,mainId,e) {
      e.stopPropagation()
      this.searchParams.mainId = parseInt(this.query.mainId)
      this.searchParams.defaultUserId = parseInt(this.query.userId)
      if (mainId == 0) {
        let index = this.searchParams.tagId.findIndex(item => item == id)
        if (index == -1) {
          this.searchParams.tagId.push(id)
        } else {
          this.searchParams.tagId.splice(index,1)
        }
      } else {
        let index = this.searchParams.wxTagId.findIndex(item => item == id)
        if (index == -1) {
          this.searchParams.wxTagId.push(id)
        } else {
          this.searchParams.wxTagId.splice(index,1)
        }
      }
      
    },
    initMallProduct() {
      this.searchParams.companyIds = this.searchParams.companyTagId
      this.searchParams.mainId = parseInt(this.query.mainId)
      this.searchParams.defaultUserId = parseInt(this.query.userId)
      this.searchParams.productTransactionCodes = this.query.productTransactionCodes
      let params = {...this.searchParams}
      if (this.searchParams.productClassTwo === '10') {
          params.productClassTwo = ''
      }
      api.initMallProduct(params).then(res => {
        this.list = res.data.content.productList
      })
    },
    closeBg() {
      this.isHide = false
      this.showBg = false
      this.activeItem()
      let hasCompanyId = this.searchParams.companyTagId && this.searchParams.companyTagId.length > 0
      let tagId = this.searchParams.tagId && this.searchParams.tagId.length > 0
      // if (!this.searchParams.productClass && !this.searchParams.productClassTwo && !hasCompanyId && !tagId) {
      //   // this.tagClassList = []
      //   return false
      // }
      this.initMallProduct()
    }
  },
  watch: {
    height: {
      handler(newHeight, oldHeight) {
        if (newHeight > 40) {
          this.showBar = true;
        } else {
          this.showBar = false;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.page_1 {
  background-color: #f8f8f8;
  margin: 0 auto;
  overflow: hidden;
  // height: 100%;
  .tit_ {
    height: 44px;
    line-height: 44px;
    background-color: #fff;
    font-size: 16px;
    color: #333;
    text-align: center;
    position: relative;
    &::before {
      content: "X";
      position: absolute;
      left: 20px;
    }
  }
  .con {
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    width: 100%;
    display: flex;
    overflow-x: auto;
    .tab {
      font-weight: 500;
      font-size: 15px;
      height: 100%;
      flex: 1;
      white-space: nowrap;
      margin: 0 6px;
    }
    // &.show {
    //   z-index: 999;
    //     background-color: #fff;
    //     position: fixed;
    //     top: 0;
    //     left: 0;
    //   }
    .active {
      font-weight: 700;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        display: block;
        width: 11px;
        height: 2px;
        border-radius: 4px;
        background-color: var(--main-color);
        transform: translateX(-50%);
      }
    }
  }
  .list {
    margin: 15px 15px 0;
    margin-top: 40px;
    .item {
      background-color: #fff;
      border-radius: 7px;
      display: flex;
      height: 135px;
      margin-bottom: 10px;
      position: relative;
      &:last-child {
        margin-bottom: 100px;
      }
      .proImg_ {
        width: 120px;
        height: 100%;
        position: relative;
        overflow: hidden;
        border-radius: 7px;
        display: flex;
        .company_ {
          position: absolute;
          bottom: 0;
          left: 0;
          background: rgba(245, 245, 245, 1);
          width: 100%;
          height: 26px;
          border-radius: 0rem 0rem 0 7px;
          font-size: 0.29rem;
          font-weight: bold;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          flex: 1;
          width: 120px;
          height: 135px;
          border-radius: 7px 7px 0 0;
        }
      }
      .right_ {
        text-align: left;
        margin-left: 10px;
        flex: 1;
        .source_ {
          white-space: pre;
          width: 200px;
          overflow: hidden;
        }
        .title {
          font-size: 16px;
          font-weight: 500;
          flex: 1;
          color: #333;
          margin-top: 13px;
          margin-bottom: 5px;
        }
        .risk {
          display: flex;
          font-size: 12px;
          color: #999;
          line-height: 16px;
        }
        .bottom_ {
          position: absolute;
          bottom: 0;
          .price {
            font-size: 18px;
            color: #ff4a35;
          }
          .unit_ {
            font-size: 11px;
            color: #666;
          }
        }
      }
    }
  }
  .btn {
    background: #fff;
    border-radius: 22px;
    width: 90%;
    height: 50px;
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
      height: 100%;
    }
    .use {
      position: absolute;
      left: 0;
      font-size: 0.426667rem;
      display: inline-block;
      font-weight: 500;
      width: 38%;
      height: 50px;
      line-height: 50px;
    }
    .txt {
      // position: absolute;
      // font-size: 16px;
      // color: #fff;
      // top: 22px;
      // left: 50%;
      // transform: translateX(-50%);
      position: absolute;
      font-size: 0.426667rem;
      color: #fff;
      /* top: 0.586667rem; */
      right: 0;
      /* bottom: 10px; */
      /* transform: translateX(-50%); */
      display: inline-block;
      border: 1px solid #eee;
      border-radius: 22px;
      height: 50px;
      line-height: 50px;
      /* margin-top: 20px; */
      width: 62%;
      background: var(--main-color);
      font-weight: 500;
    }
    .txt1 {
      position: absolute;
      font-size: 0.426667rem;
      color: #fff;
      /* top: 0.586667rem; */
      left: 0;
      top: 0;
      /* bottom: 10px; */
      /* transform: translateX(-50%); */
      // display: inline-block;
      // border: 1px solid #eee;
      border-radius: 22px;
      height: 50px;
      line-height: 50px;
      /* margin-top: 20px; */
      width: 100%;
      background: var(--main-color);
      font-weight: 500;
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    img {
      position: fixed;
      top: 25px;
      left: 78px;
    }
  }

.mask_notactive {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .desc {
        width: 200px;
        height: 60px;
        line-height: 24px;
        background: #fff;
        border-radius: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
    }
}

  .new_class {
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      height: 40px;
      z-index: 1000;
      width: 100%;
  }
  .inner_new_class {
      width: 100%;
      display: flex;
      font-size: 13px;
      color: #333333;
      height: 40px;
      background: #fff;
  }
  .new_class_item {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
  }
  .new_class_item img {
      margin-left: 7px;
      width: 10px;
      height: 10px;
  }
  .new_class_on {
      font-weight: 600;
  }
  .item_2 {
      justify-content: center;
  }
  .item_3 {
      justify-content: flex-end;
  }
  .fixed_bg {
      position: absolute;
      z-index: 201;
      width: 100%;
      height: 100vh;
      background: rgba(0,0,0,0.4);
      overflow: hidden;
  }
  .all_class {
      background: #fff;
      width: 100%;
      height: 45vh;
  }
  .inner_all_class {
      display: flex;
      border-top: 1px solid #ECECEC;
      border-bottom: 1px solid #ECECEC;
      height: 100%;
      margin-top: 39px;
  }
  .left_class {
      flex: 1;
      border-right: 1px  solid #ECECEC;
      padding-bottom: 25px;
      text-align: center;
      height: 100%;
      overflow: hidden;
  }
  .cls_list {
      height: 100%;
      width: 102%;
      overflow-y: scroll;
  }
  .left_class_selected {
      color: var(--main-color) !important;
  }
  .right_class {
      flex: 2;
      height: 100%;
  }
  .right_cls_list {
      height: 100%;
      width: 102%;
      overflow-y: scroll;
  }
.tagbox{
    width: 1.4rem;
    height: 1.4rem;
    background: #FF4A35;
    color: #fff;       /* Rotate div */
    transform:rotate(-45deg);
    -ms-transform:rotate(-45deg); /* Internet Explorer */
    -moz-transform:rotate(-45deg); /* Firefox */
    -webkit-transform:rotate(-45deg); /* Safari 闁跨喐鏋婚幏锟� Chrome */
    -o-transform:rotate(-45deg); /* Opera */
    position: absolute;
    left: -0.7rem;
    top: -0.7rem;

    }
  .tag-text{
      position: absolute;
      bottom: 4px;
      width: 100%;
      font-size: .3rem;
      text-align: center;
  }
  .right_cls_list ul {
      padding: 14px 20px 0;
  }
  .right_cls_list li {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      /*padding-left: 15px;*/
      font-size: 13px;
      color: #333333;
      margin-bottom: 10px;
  }
  .right_cls_list li .txt {
      position: absolute;
      left: 34px;
      top: 50%;
      transform: translateY(-50%);
  }
  .all_class_img {
      width: 12px;
      height: 13px;
      margin: 0 4px 0 15px;
  }
  .right_class_selected {
      background: #F8F8F8;
      border-radius: 7px;
      img {
        width: 12px;
        height: 13px;
        margin-left: 15px;
      }
      .blod_ {
        font-weight: bold;
      }
  }
  .foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 60px;
      background: #fff;
      padding: 0 53px;
  }
  .cls_btn {
      width: 85px;
      height: 30px;
      border-radius: 4px;
      font-size: 12px;
      border: none;
      outline: none;
  }
  .reset_btn {
      color: #808080;
      border: 1px solid #979797;
      background: #fff;
  }
  .confirm_btn {
      color: #fff;
      background: var(--background-color);
  }
  .cla_item {
      font-size: 13px;
      color: #333333;
      line-height: 19px;
      margin-top: 25px;
  }
  .company_class {
      width: 100%;
      max-height: 40vh;
      margin-top: 40px;
  }
  .inner_company_class {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      // height: 100%;
      padding: 0 20px 24px;
      background: #fff;
      border-bottom: 1px solid #ececec;
      overflow-y: scroll;
  }
  .company_class_item {
      width: 103px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #F8F8F8;
      font-size: 13px;
      color: #333333;
      margin-right: 8px;
      margin-top: 14px;
      border-radius: 7px;
  }
  .company_class_foot {
      padding: 17px 53px;
  }
  .company_class_selected {
      color: var(--main-color);
      background: var(--plain-color);
  }
  .tag_class {
      width: 100%;
      height: 40vh;
      background: #fff;
      margin-top: 40px;
      // padding-bottom: 17px;
  }
  .inner_tag_class {
      width: 100%;
      border-bottom: 1px solid #ececec;
      padding: 16px 20px 28px;
      height: 100%;
      overflow-y: scroll;
  }
  .tag_class_item {
      margin-top: 20px;
  }
  .tag_class_item:first-child {
      margin-top: 0;
  }
  .tag_title {
      color: #333333;
      font-weight: 600;
      font-size: 13px;
      text-align: left;
  }
  .tags_ {
      display: flex;
      flex-wrap: wrap;
  }
  .tag_ {
      width: 103px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #F8F8F8;
      font-size: 13px;
      color: #333333;
      margin-right: 8px;
      margin-top: 14px;
      border-radius: 7px;
  }
  .tag_class_foot {
      padding-top: 16px;
  }
  .tag_class_selected {
      color: var(--main-color);
      background: var(--plain-color);;
  }
}
.page_2 {
  height: 100vh;
  // margin-bottom: 12vh;
}
</style>

